import I18n from 'I18n';
import { Breadcrumbs } from 'foundations-components/transitional/components/Breadcrumbs';
import { useTheme } from 'foundations-theming/utils';
import { ACRouterLink } from 'academy-common-lib/components/ACRouterLink';
import ACSkeletonBox from 'academy-common-lib/components/loading/ACSkeletonBox';
import { jsx as _jsx } from "react/jsx-runtime";
const ACBreadcrumbNavigation = ({
  items,
  'aria-label': ariaLabel = I18n.text('academyCommon.navigation.breadcrumbAriaLabel')
}) => {
  const theme = useTheme();
  if (!items || items.length === 0) {
    return null;
  }
  const renderLabel = item => {
    if (item.isLoading) {
      return /*#__PURE__*/_jsx(ACSkeletonBox, {
        animated: true,
        backgroundcolor: theme.color['fill-surface-recessed-hover'],
        shimmercolor: theme.color['fill-surface-recessed'],
        style: {
          display: 'inline-block',
          verticalAlign: 'middle',
          width: 100,
          height: 16
        }
      });
    }
    return item.label;
  };
  return /*#__PURE__*/_jsx(Breadcrumbs, {
    "aria-label": ariaLabel,
    marginBlockEnd: "600",
    paddingInline: "0",
    children: items.map((item, index) => item.to ? /*#__PURE__*/_jsx(ACRouterLink, {
      to: item.to,
      children: renderLabel(item)
    }, `breadcrumb-${index}`) : /*#__PURE__*/_jsx("span", {
      children: renderLabel(item)
    }, `breadcrumb-${index}`))
  });
};
export default ACBreadcrumbNavigation;